export const getSubCateLinks = async (lang: string, action_id: string, 
    category_id: string,
    province: string,
    amphur: string,
    locationtypeid: string,
    locationbranchid: string,
) => {
    try {


        const url = `${process.env.BACK_END_URL || process.env.NEXT_PUBLIC_BACK_END_URL}/category/subcateurl`;
        console.log('getSubCateLinks ', url);

        let body = {};
        if(action_id) {
            body = {
                ...body,
                action_id
            }
        }

        if(category_id) {
            body = {
                ...body,
                category_id
            }
        }

        body = {
            ...body,
            province,
            amphur,
            locationtypeid,
            locationbranchid
        }

        console.log('body: ', body)

        const res = await fetch(encodeURI(url),
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Accept-Language': `${lang.toUpperCase()}`
                },
                body: JSON.stringify(body)
            }
        )
        const data = await res.json()

        if (!data) {
            return {
                notFound: true,
            }
        }
        return data;
    } catch (e) {
        console.log('search error: ', e)
        return [];
    }
}

export const getGroupCateId = async (lang: string, name: string) => {
    try {
        const url = `${process.env.BACK_END_URL || process.env.NEXT_PUBLIC_BACK_END_URL}/subcate/group/${name}`;

        const res = await fetch(encodeURI(url),
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Accept-Language': `${lang.toUpperCase()}`
                }
            }
        )
        const data = await res.json()

        if (!data) {
            return {
                notFound: true,
            }
        }
        return data;
    } catch (e) {
        console.log('search error: ', e)
        return [];
    } 
}

export const getGroupCateByName = async (lang: string,
    action_id: string,
    category_id: string,
    name: string,
    group_category_id: string) => {
    try {
        let url = `${process.env.BACK_END_URL || process.env.NEXT_PUBLIC_BACK_END_URL}/category`
        url += '/subcateurlByName';

        console.log('getGroupCateByName ', url);

        let body: {
            action_id?: string,
            category_id?: string,
            name: string,
            group_category_id: string
        } = {
            name: name,
            group_category_id
        };

        if(action_id) {
            body = {
                ...body,
                action_id
            }
        }

        if(category_id) {
            body = {
                ...body,
                category_id
            }
        }

        console.log('body: ', body)

        const res = await fetch(encodeURI(url),
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8',
                    'Accept-Language': `${lang.toUpperCase()}`
                },
                body: JSON.stringify(body)
            }
        )
        const data = await res.json()

        if (!data) {
            return {
                notFound: true,
            }
        }
        return data;
    } catch (e) {
        console.log('search error: ', e)
        return [];
    }
}